module.exports = __webpack_public_path__ + "static/media/finance.13c91bac.png";